import { call, put, takeEvery, select } from 'redux-saga/effects'

import {
  GET_JEWELSBYVALUE_REQUESTED,
  GET_CLIENTFACETS_REQUESTED,
  GET_SEARCHCLIENTS_REQUESTED,
  GET_DEALFACETS_REQUESTED,
  GET_SEARCHDEALS_REQUESTED,
  GET_CRIMINAL_REQUESTED,
  GET_GOVERNMENT_AGENCY_REQUESTED,
  FETCH_DEAL_NUMBERS_REQUEST,
  GET_GLOBALSEARCH_REQUESTED,
} from '../actions/actionTypes'
import {
  searchJewelsSuccess,
  searchJewelsFailed,
  getClientFacetsSuccess,
  getClientFacetsFailed,
  searchClientsSuccess,
  searchClientsFailed,
  getDealFacetsSuccess,
  getDealFacetsFailed,
  searchDealsSuccess,
  searchDealsFailed,
  searchCriminalSuccess,
  searchCriminalFailed,
  searchGovernmentAgencySuccess,
  searchGovernmentAgencyFailed,
  fetchDealNumbersSuccess,
  fetchDealNumbersFailed,
} from '../actions/searchAction'
import { messages } from '../../helpers/messages'
import { searchService } from '../../services/search-service'
import {listRoles, pageOptions} from '../../helpers/data-constants'
import {convertFacets, methodsSearchDeals, buildRequest} from '../../helpers/common'
import {SESSION_BY_ID} from "../../constants/token";
import {USER_INFO} from "../../constants/localStorageConstants";
import { dealService } from '../../services/deals-service'

const searchJewels = async ({ value, size }) =>
  await searchService
    .searchJewels(value, size)
    .then(({ data }) => data.results)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getClientFacets = async () =>
  await searchService
    .getClientFacets()
    .then(({ data }) => data.facets)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const searchClients = async (payload) =>
  await searchService
    .searchClients(payload)
    .then(({ data: { total, results } }) => ({ total, results }))
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const globalSearch = async (payload) =>
  await searchService
    .searchGlobal(payload)
    .then(({ data: { total, indices, results } }) => ({ total, indices, results }))
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getDealFacets = async () =>
  await searchService
    .getDealsFacets()
    .then(({ data }) => data.facets)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const searchDeals = async (payload) =>
  await searchService
    .searchDeals(payload)
    .then(({ data: { total, results } }) => ({ total, results }))
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const searchCriminal = async (payload) =>
  await searchService
    .searchCriminal(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const searchGovernmentAgency = async (payload) =>
  await searchService
    .getGovernmentAgency(payload)
    .then(({ data }) => data.results)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const serachDealNumbers = async (payload) =>
  await dealService
    .fetchDealNumbers(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

function* fetchSearchJewels({ payload }) {
  try {
    const jewels = yield call(() => searchJewels(payload))
    yield put(searchJewelsSuccess(jewels))
  } catch (error) {
    yield put(searchJewelsFailed(error))
  }
}

function* fetchGetClientFacets({payload}) {
  try {
    const facets = yield call(getClientFacets)
    const initialFilters = yield select(state => state.search.clientFacetData)

    const dataFacets = {
      cashboxes: convertFacets(facets.cashbox),
      branches: convertFacets(facets.branch),
      amountRangeMinMax: [facets.total.min, facets.total.max],
      requestsRangeMinMax: [facets.count.min, facets.count.max],
      pageRange: pageOptions[0].value,
    }
    const req = buildRequest(dataFacets, payload || initialFilters)

    const results = yield call(searchClients, req)
    yield put(getClientFacetsSuccess({ dataFacets, results }))
  } catch (error) {
    yield put(getClientFacetsFailed(error))
  }
}

function* fetchSearchClients({ payload }) {
  try {
    const results = yield call(searchClients, payload)

    yield put(searchClientsSuccess(results))
  } catch (error) {
    yield put(searchClientsFailed(error))
  }
}

function* fetchGlobalSearch({ payload }) {
  try {
    const results = yield call(globalSearch, payload)

  if(results.indices === 'clients') {
    yield put(searchClientsSuccess(results))
  } else {
    yield put(searchDealsSuccess(results))
  }
  } catch (error) {
    yield put(searchClientsFailed(error))
  }
}

function* fetchGetDealFacets({ payload }) {
  try {
    const facets = yield call(getDealFacets)
    const userCashBox = JSON.parse(localStorage.getItem(SESSION_BY_ID))
    const userInfo = JSON.parse(localStorage.getItem(USER_INFO))
    const goodSpecialist = (userInfo.roles.length === 1 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST)) ||
      (userInfo.roles.length === 2 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST && listRoles.LOYAL_GOODS_SPECIALIST));
    const dealFacetData = {
      cashbox: methodsSearchDeals.sort(facets.cashbox),
      branch: methodsSearchDeals.sort(facets.branch),
      purityName: methodsSearchDeals.sort(facets.purityName),
      purityType: methodsSearchDeals.sort(facets.purityType),
      dealType: methodsSearchDeals.sort(facets.dealType),
      status: methodsSearchDeals.sort(facets.status),
      carBrand: methodsSearchDeals.sort(facets.carBrand),
      carDate: methodsSearchDeals.sort(facets.carDate),
      pageRange: pageOptions[0].value,
      amount: [facets.amount.min, facets.amount.max],
    }
    let req = methodsSearchDeals.buildRequest(dealFacetData, payload)

    if (goodSpecialist) {
      req = {...req,
        facets: req.facets.map(el => el.name === 'cashbox' ? {...el, values: [userCashBox.label]} : el)}
    }

    const resultsDeals = yield call(searchDeals, req)
    yield put(getDealFacetsSuccess({ dealFacetData, resultsDeals }))
  } catch (error) {
    yield put(getDealFacetsFailed(error))
  }
}

function* fetchSearchDeals({ payload }) {
  try {
    const userInfo = JSON.parse(localStorage.getItem(USER_INFO))
    const goodSpecialist = (userInfo.roles.length === 1 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST)) ||
      (userInfo.roles.length === 2 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST && listRoles.LOYAL_GOODS_SPECIALIST));
    const userCashBox = JSON.parse(localStorage.getItem(SESSION_BY_ID))

    if (goodSpecialist) {
      payload = {...payload,
        facets: payload.facets.map(el => el.name === 'cashbox' ? {...el, values: [userCashBox.label]} : el)}
    }

    const results = yield call(searchDeals, payload)

    yield put(searchDealsSuccess(results))
  } catch (error) {
    yield put(searchDealsFailed(error))
  }
}

function* fetchSearchCriminals({ payload }) {
  try {
    let { results, total } = yield call(searchCriminal, payload)

    if (total > payload.size) {
      payload.size = total
      results = yield call(searchCriminal, payload)
      results = results.results
    }

    yield put(searchCriminalSuccess(results))
  } catch (error) {
    yield put(searchCriminalFailed(error))
  }
}

function* fetchSearchGovernmentAgency({ payload }) {
  try {
    const governmentAgency = yield call(searchGovernmentAgency, payload)
    yield put(searchGovernmentAgencySuccess(governmentAgency))
  } catch (error) {
    yield put(searchGovernmentAgencyFailed(error))
  }
}

function* fetchDealNumbers(action) {
  try {
    const { payload: ids } = action;
    const { dealNumberMap } = yield call(serachDealNumbers, ids);
    yield put(fetchDealNumbersSuccess(dealNumberMap));
  } catch (error) {
    yield put(fetchDealNumbersFailed(error));
  }
}

function* searchJewelsSaga() {
  yield takeEvery(GET_JEWELSBYVALUE_REQUESTED, fetchSearchJewels)
}

function* getClientFacetsSaga() {
  yield takeEvery(GET_CLIENTFACETS_REQUESTED, fetchGetClientFacets)
}

function* searchClientsSaga() {
  yield takeEvery(GET_SEARCHCLIENTS_REQUESTED, fetchSearchClients)
}

function* globalSearchSaga() {
  yield takeEvery(GET_GLOBALSEARCH_REQUESTED, fetchGlobalSearch)
}

function* getDealFacetsSaga() {
  yield takeEvery(GET_DEALFACETS_REQUESTED, fetchGetDealFacets)
}

function* searchDealsSaga() {
  yield takeEvery(GET_SEARCHDEALS_REQUESTED, fetchSearchDeals)
}

function* searchCriminalsSaga() {
  yield takeEvery(GET_CRIMINAL_REQUESTED, fetchSearchCriminals)
}

function* searchGovernmentAgencySaga() {
  yield takeEvery(GET_GOVERNMENT_AGENCY_REQUESTED, fetchSearchGovernmentAgency)
}

function* searchDealNumbersSaga() {
  yield takeEvery(FETCH_DEAL_NUMBERS_REQUEST, fetchDealNumbers);
}

export {
  searchJewelsSaga,
  getClientFacetsSaga,
  searchClientsSaga,
  globalSearchSaga,
  getDealFacetsSaga,
  searchDealsSaga,
  searchClients,
  searchCriminalsSaga,
  searchGovernmentAgencySaga,
  searchDealNumbersSaga
}
